import { Modal, Slider, Typography } from "@mui/material";
import { useState } from "react";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

const ImagePreview = ({ open, imageSrc, onClose }) => {
    const [zoomStyle, setZoomStyle] = useState({
        transform: "scale(1)",
        transformOrigin: "center center",
    });

    const [scale, setScale] = useState(50); // scale 0-100%

    if (!imageSrc) return null;

    // Mouse move handler for cursor-based zoom
    const handleMouseMove = (e) => {
        const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
        const x = ((e.clientX - left) / width) * 100;
        const y = ((e.clientY - top) / height) * 100;

        const zoomFactor = 1 + scale / 100;

        setZoomStyle({
            transform: `scale(${zoomFactor})`,
            transformOrigin: `${x}% ${y}%`,
        });
    };

    const handleMouseLeave = () => {
        setZoomStyle({
            transform: "scale(1)",
            transformOrigin: "center center",
        });
    };

    // Slider handler
    const handleScaleChange = (e, value) => {
        setScale(value);
        const zoomFactor = 1 + value / 100;
        setZoomStyle((prev) => ({
            ...prev,
            transform: zoomFactor > 1 ? `scale(${zoomFactor})` : "scale(1)",
        }));
    };

    return (
        <Modal open={open} onClose={onClose}>
            <MDBox
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 600,            // fixed width
                    height: 600,           // fixed height
                    bgcolor: "background.paper",
                    p: 2,
                    borderRadius: 2,
                    boxShadow: 24,
                    outline: "none",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {/* Close Button */}
                <MDBox display="flex" justifyContent="flex-end" mb={1}>
                    <MDButton
                        size="small"
                        variant="outlined"
                        color="secondary"
                        onClick={onClose}
                    >
                        Cancel
                    </MDButton>
                </MDBox>

                {/* Zoom Scale Slider */}
                <MDBox mb={1} px={1}>
                    <Typography variant="caption" gutterBottom>
                        Zoom Scale: {scale}%
                    </Typography>
                    <Slider
                        value={scale}
                        min={0}
                        max={100}
                        onChange={handleScaleChange}
                        size="small"
                    />
                </MDBox>

                {/* Image Container */}
                <MDBox
                    sx={{
                        flex: 1,
                        overflow: "hidden",
                        borderRadius: 1,
                        cursor: "zoom-in",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    onMouseMove={handleMouseMove}
                    onMouseLeave={handleMouseLeave}
                >
                    <MDBox
                        component="img"
                        src={imageSrc}
                        alt="Preview"
                        sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            transition: "transform 0.2s ease",
                            ...zoomStyle,
                        }}
                    />
                </MDBox>
            </MDBox>
        </Modal>
    );
};

export default ImagePreview;
